// Connection state for the offline-tolerant store (public/sw.js).
// The service worker can show saved catalogue pages offline, but adding to
// the bag and checking out always need the network: those buttons say so
// instead of failing silently (CartContext.addItem, EnhancedCheckout).
import { toast } from 'sonner';

/** True only when the browser knows it is offline (navigator.onLine === false). */
export const isOffline = () => {
  try { return typeof navigator !== 'undefined' && navigator.onLine === false; } catch { return false; }
};

export const OFFLINE_BAG_TEXT = {
  en: "You're offline. Connect to the internet to add pieces to your bag.",
  ar: 'أنت غير متصل بالإنترنت. اتصل بالإنترنت لإضافة القطع إلى حقيبتك.',
};

const pageLanguage = () => {
  // "ar" from LanguageContext, "ar-AE" once SEOHead has run.
  try { return /^ar\b/i.test(document.documentElement.lang) ? 'ar' : 'en'; } catch { return 'en'; }
};

/** One toast (same id: repeated taps never stack) in the page's language; returns the text. */
export const notifyOffline = (text = OFFLINE_BAG_TEXT, language = pageLanguage()) => {
  const message = text[language] || text.en;
  toast.error(message, { id: 'anum-offline-action' });
  return message;
};
